<template>
  <!-- <f7-page class="" id="contacts"> -->
  <div class="page rowBackgroundHomepage">
    <div v-if="isSmartphoneOS">
      <f7-navbar style="position:absolute;top:44px;" v-if="false">
        <b-row no-gutters style="text-align:center;width:100%;">
          <b-col>
            <f7-button round class="statusButton"
              :class="currentRole === 'simple' ? 'navbar-button-selected': 'navbar-button'"
              @click="changeCurrentRole('simple')"
              tab-link=".contactTab1">
              {{ $t('common.contacts_label') }}
            </f7-button>
          </b-col>
          <b-col>
            <f7-button round class="statusButton"
              :class="currentRole === 'group' ? 'navbar-button-selected': 'navbar-button'"
              @click="changeCurrentRole('group')"
              tab-link=".contactTab2">
              {{ $t('common.groups_label') }}
            </f7-button>
          </b-col>
        </b-row>
      </f7-navbar>
      <f7-searchbar class="search" v-if="isSmartphoneOS"
        style="position:absolute;top:44px;width:100%;z-index:10;"
        id="searchBankAccount"
        :cancel-link="$t('common.cncl')"
        search-list="#bank-list"
        :placeholder="searchInLabel"
        @searchbar:search="onSearch"
        @searchbar:clear="onClear">
      </f7-searchbar>
    </div>
    <div class="showSmallScreenOnly">
      <f7-fab class="leftfav3 button-fab bottomButton"
        v-if="currentRole === 'simple'"
        @click="OpenFormsPageContact">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav3 button-fab bottomButton"
        v-if="currentRole === 'group'"
        @click="OpenFormsPageContactGroup">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav2 bottomButton" href="/contact/import">
        <f7-icon f7="bullet_list"></f7-icon>
      </f7-fab>

      <f7-fab class="leftfav button-fab bottomButton"
        @click="extractCSV(contacts, contactGroups)">
        <f7-icon f7="document_text"></f7-icon>
      </f7-fab>

      <f7-fab id="contactDeleteButton" class="button-fab bottomButton contactDeleteButtonPosition"
        v-if="multipleContactsDelete.length > 0"
        @click="deleteMultipleContacts">
        <f7-icon f7="trash"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content">
      <div class="layoutTop" v-if="!isSmartphoneOS"></div>
      <div v-else-if="false" style="height:132px;"></div>
      <div v-else style="height:88px;"></div>
      <div class="listPage">
        <b-row class="form-group justify-content-start showLargeScreenOnly">
          <b-col sm="3" xl="2" v-if="currentRole === 'simple'">
            <f7-button class="button-action milkyBlockBlack"
              @click="OpenFormsPageContact"
              :disabled="canAdd">
              <f7-icon f7="add"></f7-icon>
              <span>{{ $t('common.add_label') }}</span>
            </f7-button>
          </b-col>
          <b-col sm="3" xl="2" v-if="currentRole === 'group'">
            <f7-button class="button-action milkyBlockBlack"
              @click="OpenFormsPageContactGroup">
              <f7-icon f7="add"></f7-icon>
              <span>{{ $t('common.add_label') }}</span>
            </f7-button>
          </b-col>
          <!-- <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack">
              <a href="/contact/import">
                <f7-icon f7="bullet_list"></f7-icon>
                <span>{{ importLabel }}</span>
              </a>
            </f7-button>
          </b-col> -->
          <b-col sm="2">
            <f7-button class="button-action milkyBlockBlack"
              @click="extractCSV(contacts, contactGroups)">
              <f7-icon f7="document_text"></f7-icon>
              <span>{{ $t('common.extract') }}</span>
            </f7-button>
          </b-col>
        </b-row>
        <b-row v-if="!isSmartphoneOS && false">
          <b-col>
            <div class="contactButtonContainer">
              <f7-grid no-gutter>
                <f7-col width="50" class="pilotageTabController">
                  <f7-link class="pilotageLink" style="border-top-left-radius: 10px;"
                    :class="{tabActive: currentRole === 'simple', tabUnactive: currentRole !== 'simple'}"
                    tab-link=".contactTab1"
                    @click="changeCurrentRole('simple')" active>
                    {{ $t('common.contacts_label') }}
                  </f7-link>
                </f7-col>
                <f7-col width="50" class="pilotageTabController">
                  <f7-link class="pilotageLink" style="border-top-right-radius: 10px;"
                    :class="{tabActive: currentRole === 'group', tabUnactive: currentRole !== 'group'}"
                    tab-link=".contactTab2"
                    @click="changeCurrentRole('group')">
                    {{ $t('common.groups_label') }}
                  </f7-link>
                </f7-col>
              </f7-grid>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <f7-tabs>
              <f7-tab class="contactTab1" active>
                <f7-searchbar v-if="!isSmartphoneOS"
                  class="search webdatalist"
                  cancel-link="Cancel"
                  search-list="#contacts-list"
                  :placeholder="searchInLabel"
                  :clear-button="true"
                  @searchbar:search="onSearch"
                  @searchbar:clear="onClear">
                </f7-searchbar>
                <div class="itemList">
                  <cm-contact-list :filterBy="filterBy" :contacts="contacts"></cm-contact-list>
                  <cm-pagination
                    :firstIndex="paginationObject.firstIndex"
                    :maxResultsByPage="paginationObject.maxResults"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </div>
              </f7-tab>
              <f7-tab class="contactTab2">
                <f7-searchbar v-if="!isSmartphoneOS"
                  class="webdatalist"
                  cancel-link="Cancel"
                  search-list="#group-list"
                  :placeholder="searchInLabel"
                  @searchbar:search="onGroupSearch"
                  @searchbar:clear="onGroupClear">
                </f7-searchbar>
                <div class="itemList">
                  <cm-contact-group-list :filterBy="groupFilterBy" :contactGroups="contactGroups"></cm-contact-group-list>
                  <cm-pagination
                    :firstIndex="paginationObjectGroup.firstIndex"
                    :maxResultsByPage="paginationObjectGroup.maxResults"
                    :nbResultsTotal="paginationObjectGroup.nbResultsTotal"
                    :refreshEvent="paginationObjectGroup.refresh">
                  </cm-pagination>
                </div>
              </f7-tab>
            </f7-tabs>
          </b-col>
        </b-row>
        <div class="toolbarPageBottomBlank"></div>
      </div>
    </div>
  </div>
</div>
<!-- </f7-page> -->
</template>

<script>
import moment from 'moment'

import pagination from '@/components/common/pagination.vue'

import ContactGroupList from './CMContactsPage/CMContactGroupList.vue'
import ContactList from './CMContactsPage/CMContactList.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'contacts',
  components: {
    'cm-contact-group-list': ContactGroupList,
    'cm-contact-list': ContactList,
    'cm-pagination': pagination
  },
  data () {
    return {
      contactListLabel: '',
      importLabel: '',
      currentRole: 'simple',
      contacts: [],
      contactGroups: [],
      multipleContactsDelete: [],
      filterBy: '',
      groupFilterBy: '',
      service: '',
      paginationObject: {},
      paginationObjectGroup: {},
      backgroundColor: '',
      canImport: false
    }
  },
  created () {
    let that = this
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$i18n.t('Webheader.my_contacts'),
      returnUrl: ''
    })
    this.importLabel = this.$i18n.t('common.import_contacts')
    this.contactListLabel = this.$i18n.t('common.contacts_list')
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 10
    this.paginationObject['nbResultsTotal'] = 0
    this.paginationObject['refresh'] = 'refresh-cache-contacts'
    this.paginationObjectGroup['firstIndex'] = 1
    this.paginationObjectGroup['maxResults'] = 10
    this.paginationObjectGroup['nbResultsTotal'] = 0
    this.paginationObjectGroup['refresh'] = 'refresh-cache-groups'
    /* Turn off all buses events */
    // this.$bus.$off('inbox-filtered')
    this.$bus.$off('sendbox-filtered')
    // this.$bus.$off('refresh-cache-service')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-groups')
    // this.$bus.$off('refresh-cache-attachments-view')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-cache-contacts', (index) => {
      that.setContacts(index)
    })
    this.$bus.$on('refresh-cache-groups', (index) => {
      this.setContactGroups(index)
    })
    that.setContacts()
    this.setContactGroups()
    that.$$(document).off('taphold', '.blueConfirmationButtonActivationOK2')
    that.$$(document).on('taphold', '.testTap', function () {
      if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === false) {
        that.multipleContactsDelete.push(that.$$(this).data('item'))
        that.$$(this).addClass('listItemSelected')
      } else if (that.multipleContactsDelete.includes(that.$$(this).data('item')) === true) {
        let index = that.multipleContactsDelete.indexOf(that.$$(this).data('item'))
        if (index > -1) {
          that.multipleContactsDelete.splice(index, 1)
        }
        that.$$(this).removeClass('listItemSelected')
      }
    })
    this.service = this.$engine.user.currentService.name
  },
  mounted () {
    // Afin de changer les paramètres de la page active
    this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
  },
  computed: {
    canAdd () {
      return this.$engine.rights.rightIs('business_members_ajouter', false)
    },
    getColor: function () {
      /* return {
        'tabActive_DD': this.$engine.user.currentService.name === 'Direct Debit',
        'tabActive_P': this.$engine.user.currentService.name === 'Payments',
        'tabActive': this.$engine.user.currentService.name === 'Direct Payments'
      } */
      return 'tabActive'
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    searchInLabel () {
      if (this.currentRole === 'group') {
        return this.$i18n.t('contacts.srch_in_grps')
      } else {
        return this.$i18n.t('contacts.srch_in_cntcts')
      }
    }
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
      this.setContacts()
    },
    onClear: function () {
      this.filterBy = ''
    },
    extractCSV (contacts, contactGroups) {
      let firstLine = ''
      let lines = ''
      let fileName = ''
      let today = moment()
      let serviceFileName = ''
      if (this.service === 'Direct Debit') {
        serviceFileName = 'ModularLoan'
      } else if (this.service === 'Direct Payments') {
        serviceFileName = 'DirectPayments'
      } else {
        serviceFileName = 'RequestToPay'
      }
      if (this.currentRole === 'simple') {
        firstLine = this.$i18n.t('common.als') + ';' + this.$i18n.t('common.nme') + '\r\n'
        fileName = 'contact' + serviceFileName + today.unix() + '.csv'
        for (var kc in contacts) {
          for (var kkc in contacts[kc]) {
            lines += contacts[kc][kkc].label + ';' + contacts[kc][kkc].name + '\r\n'
          }
        }
      } else {
        firstLine = this.$i18n.t('common.als') + '\r\n'
        fileName = 'contactGroup' + serviceFileName + today.unix() + '.csv'
        for (var kcg in contactGroups) {
          for (var kkcg in contactGroups[kcg]) {
            lines += contactGroups[kcg][kkcg].label + '\r\n'
          }
        }
      }
      let data = firstLine + lines

      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onGroupSearch (query, found) {
      this.groupFilterBy = query
      this.setContactGroups()
    },
    onGroupClear () {
      this.groupFilterBy = ''
    },
    changeCurrentRole (role) {
      if (this.currentRole !== role) {
        this.currentRole = role
      }
      // if (this.currentRole === 'simple') {
      //   this.Dom7('.contactTab2').removeClass('active')
      //   this.Dom7('.contactTab1').addClass('active')
      //   this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
      // } else if (this.currentRole === 'group') {
      //   this.Dom7('.contactTab1').removeClass('active')
      //   this.Dom7('.contactTab2').addClass('active')
      //   this.$bus.emit('refresh-cache-paging-template', this.paginationObjectGroup)
      // }
    },
    setContacts (index = 1) {
      var contactList = {}
      let nbElement = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResults = 0
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var contact = this.$engine.contacts.get(j)
        if (contact.label.toLowerCase().includes(this.filterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObject.firstIndex <= nbElement && nbElement < (this.paginationObject.firstIndex + this.paginationObject.maxResults)) {
            var firstLetter = contact.label.substr(0, 1).toUpperCase()
            if (!contactList.hasOwnProperty(firstLetter)) {
              contactList[firstLetter] = []
            }
            contactList[firstLetter].push({
              id: contact.id,
              label: contact.label,
              iban: contact.iban,
              identifier: contact.identifier,
              name: contact.name,
              phoneNumber: contact.phoneNumber,
              address: contact.address,
              city: contact.city,
              zipCode: contact.zipCode,
              country: contact.country,
              typeContact: contact.typeContact,
              zoneCode: contact.zoneCode
            })
            contactList[firstLetter].sort()
            this.paginationObject.nbResults++
          }
        }
      }
      this.paginationObject.nbResultsTotal = nbElement
      this.contacts = this.orderKeys(contactList)
      // this.$bus.on => src/components/common/pagination.vue
      this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
    },
    setContactGroups (index = 1) {
      var contactGroupList = {}
      let nbElement = 0
      this.paginationObjectGroup.firstIndex = index
      this.paginationObjectGroup.nbResults = 0
      for (var j = 0; j < this.$engine.contacts.getContactGroup().length; j++) {
        var contactGroup = this.$engine.contacts.getContactGroup(j)
        if (contactGroup.label.toLowerCase().includes(this.groupFilterBy.toLowerCase())) {
          nbElement++
          if (this.paginationObjectGroup.firstIndex <= nbElement && nbElement < (this.paginationObjectGroup.firstIndex + this.paginationObjectGroup.maxResults)) {
            var firstLetter = contactGroup.label.substr(0, 1).toUpperCase()
            if (!contactGroupList.hasOwnProperty(firstLetter)) {
              contactGroupList[firstLetter] = []
            }
            contactGroupList[firstLetter].push({
              label: contactGroup.label,
              contacts: contactGroup.contacts,
              id: contactGroup.id
            })
            contactGroupList[firstLetter].sort()
            this.paginationObjectGroup.nbResults++
          }
        }
      }
      this.paginationObjectGroup.nbResultsTotal = nbElement
      this.contactGroups = this.orderKeys(contactGroupList)
      this.$bus.emit('refresh-cache-paging-template', this.paginationObjectGroup)
    },
    orderKeys (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    OpenFormsPageContact () {
      this.clearPage()
      loadPage(this, {url: '/account/addContact/'})
    },
    OpenFormsPageContactGroup () {
      loadPage(this, {url: '/account/addContactGroup/'})
    },
    // OpenFormsPageContact () {
    //   if (this.Dom7('#simpleContact').last().hasClass('active')) {
    //     this.clearPage()
    //     loadPage(this, {url: '/account/addContact/'})
    //   } else if (this.Dom7('#contactGroup').last().hasClass('active')) {
    //     loadPage(this, {url: '/account/addContactGroup/'})
    //   }
    // },
    deleteMultipleContacts () {
      let that = this
      that.$f7.confirm('Are you sure to delete these contacts?', 'Operation confirmation', function () {
        that.$engine.contacts.deleteMultipleContacts(that.multipleContactsDelete)
        .then(resp => {
          that.$f7.modal({
            title: 'Contacts deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.multipleContactsDelete = []
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          errorMessageAlert(err, that)
        })
      })
    },
    clearPage () {
      this.$$('.testTap').removeClass('listItemSelected')
      // this.$$('#contactDeleteButton').css('visibility', 'hidden')
      this.multipleContactsDelete = []
    }
  }
}
</script>

<style scoped>
/* .pilotageLink.active {
  background-color: #12bcf1;
  color: white;
} */
@media (max-width: 768px) {
  .toolbarPageBottomBlank{
    height: 175px;
  }
}
</style>



// WEBPACK FOOTER //
// CMContactsPage.vue?e07a2320